import { useEffect, useState } from 'react'

import { issueRefundAtStatusValues } from '@/common/constants'

import { transactionalStatuses } from './constants'

const useSelectedOrders = ({ orders }) => {
  const [selectedOrders, setSelectedOrders] = useState([])
  const [usableOrders, setUsableOrders] = useState([])
  const [notUsableOrders, setNotUsableOrders] = useState([])

  useEffect(() => {
    if (orders) {
      setUsableOrders(
        orders?.filter(order => selectedOrders.includes(order.id) && transactionalStatuses.includes(order?.status))
      )

      setNotUsableOrders(
        orders?.filter(order => selectedOrders.includes(order.id) && !transactionalStatuses.includes(order?.status))
      )
    }
  }, [orders, selectedOrders])

  const getSelectedOrdersAllowIssueRefund = () => {
    return usableOrders?.some(order => order?.allows_issue_refund && Number(order?.remaining_amount) > 0)
  }

  const getSelectedOrdersAllowManageRestock = () => {
    return usableOrders?.some(order => order?.allows_manage_restock)
  }

  const getSelectedOrdersAllowsExchangeOrderProcessing = () => {
    return usableOrders?.some(order => order?.allows_exchange_order_processing)
  }

  const getOrdersWithRemainingAmount = () => {
    return usableOrders?.filter(order => order.refund_status === 'pending' && Number(order?.remaining_amount) > 0)
      ?.length
  }

  const getOrdersWithRequestedProducts = () => {
    return usableOrders?.filter(order => order?.has_items_with_exchange && order?.allows_exchange_order_processing)
      ?.length
  }

  const getSelectedOrdersIssueRefundAtStatus = () => {
    return usableOrders?.some(order => order?.issue_refund_at_status === issueRefundAtStatusValues.accepted)
      ? issueRefundAtStatusValues.accepted
      : null
  }

  return {
    selectedOrders,
    setSelectedOrders,
    usableOrders,
    notUsableOrders,
    getSelectedOrdersAllowIssueRefund,
    getSelectedOrdersAllowManageRestock,
    getSelectedOrdersAllowsExchangeOrderProcessing,
    getOrdersWithRemainingAmount,
    getOrdersWithRequestedProducts,
    getSelectedOrdersIssueRefundAtStatus,
  }
}

export default useSelectedOrders
